import "./main.scss";

import { BrowserRouter as Router, useLocation } from "react-router-dom";

import { PaymentProvider } from "./providers/payment/payment.provider";
import { setAppToken } from "./setup/context/api";
import React, { Suspense, useEffect, useState } from "react";
const NavBar = React.lazy(() => import("./components/navbar"));
const Routes = React.lazy(() => import("./setup/routes"));

// styles
import styles from "./App.module.scss";

export const App = () => {
  const [isAuth, setIsAuth] = useState<boolean>();

  useEffect(() => {
    setAppToken();
  }, []);

  useEffect(() => {
    let token: string | null = null;
    if (localStorage) token = localStorage?.getItem("userToken");
    setIsAuth(!!token);
  }, []);

  return (
    <div
      className={!isAuth ? styles["auth_container"] : styles["container"]}
      dir="rtl">
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <Suspense fallback={<div />}>
        <PaymentProvider>
          <Router>
            <NavBar />
            <Routes />
          </Router>
        </PaymentProvider>
      </Suspense>
    </div>
  );
};
